
import { useEffect, useState } from 'react';
import styles from './Profile.module.css';
import { IoCloseOutline } from "react-icons/io5";
import KidProfileForm from 'components/profileForm/kidProfileForm';
import { useNavigate } from 'react-router-dom';
import Popup from 'components/Popup/popup';
import { getParentData } from 'services/profileManegement/get-parent-data';
import { checkSession } from 'services/userLogin/check-session';


export default function KidProfile() {
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        first_name: "",
        last_name: "",
        birth_date: new Date(),
        country: "",
        age: 0,
        zip: "",
        city: "",
        street: "",
        allergy_medication: "",
        note: "",
    });

    const [isPopupOpen, setIsPopupOpen] = useState(true);
    const maxBirthDate = new Date();
    const minBirthDate = new Date();
    minBirthDate.setFullYear(maxBirthDate.getFullYear() - 10);

    const closePopup = () => {
        setIsPopupOpen(false);
    };
    const dataTransfer = async () => {
        try {
            const parentData = await getParentData();
            const data = parentData.data;
            if (parentData.success) {
                setInitialValues(prevValues => ({
                    ...prevValues,
                    ...data
                }));
            }
        } catch (error) {
            console.error("Fehler beim Laden von Eltern Daten:", error);
        } finally {
            closePopup();
        }
    }
    const verifySession = async () => {
        try {
            const sessionData = await checkSession();
            if (!sessionData.session_active) {
                navigate('/reservierungsportal', { replace: true });
            }
        } catch (error) {
            console.error("Fehler bei der Sitzungsprüfung:", error);
        }
    };

    useEffect(() => {
        verifySession();
    }, []);

    return (
        <div className={styles.container}>
            {isPopupOpen && <Popup onClose={closePopup} title={'Sollen die Daten aus dem Profil hier übernommen werden?'}
                children={undefined}
                submitLabel={'Daten übernehmen'}
                closeLabel={'Abbrechen'}
                onSubmit={dataTransfer}
                isWithButton={true}
                isOpen={true} />}

            <div className={styles.header}>
                <div>
                    <a className={styles.closeButton} onClick={() => window.history.back()}>
                        <IoCloseOutline />
                    </a>
                    <h2>Profil für ein Kind erstellen</h2>
                </div>
            </div>
            <KidProfileForm initialValues={initialValues}
                buttonOptions={[
                    {
                        label: "Zurück",
                        onClick: () => {
                            window.history.back();
                        },
                    },
                    {
                        label: "Speichern",
                    },
                ]}
                onSubmitSuccess={() => {
                    navigate('/reservierungsportal/NewkidsProfile');
                }} />
        </div>
    );
}

